/**
 * Resolves the success/partial-stock pill shape shared by both order types
 * and reused anywhere else stock-status copy needs to match the line-item
 * pill (e.g. the product-list stock summary).
 *
 * - Full stock (`currentInventory >= quantity`): success pill.
 * - Partial stock: warning pill with "Kun {currentInventory} av {quantity}".
 * - `storeName` present -> Click and Collect copy ("hos {storeName}");
 *   omitted -> Online copy ("på lager").
 */
export function resolveStockPill(
  currentInventory: number,
  quantity: number,
  storeName?: string
): { type: 'success' | 'warning'; message: string } {
  if (currentInventory >= quantity) {
    return {
      type: 'success',
      message: storeName ? `Tilgjengelig hos ${storeName}` : 'Tilgjengelig på lager',
    };
  }
  return {
    type: 'warning',
    message: storeName
      ? `Kun ${currentInventory} av ${quantity} tilgjengelig hos ${storeName}`
      : `Kun ${currentInventory} av ${quantity} på lager`,
  };
}
